import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import HeroBanner from './HeroBanner/HeroBanner'
import { HeroBannerContainerProps } from './HeroBannerContainer.types'
import { StyledContainer } from './styles'
import { SafeHtmlContent } from 'site/shared/components/SafeHtmlContent'

const HeroBannerContainer = ({ props }: HeroBannerContainerProps) => {
  const styleProps = useStyleMaps(props.styleMap)

  return (
    <StyledContainer style={styleProps}>
      <HeroBanner
        {...props}
        des={props.des ? <SafeHtmlContent html={props.des} /> : ''}
        complement={
          props.complement ? <SafeHtmlContent html={props.complement} /> : ''
        }
        desColor={props.desColor || '#ffffff'}
        complementColor={props.complementColor || '#ffffff'}
        backgroundPositionDesktop='center'
        backgroundPositionMobile='center'
      />
    </StyledContainer>
  )
}

export default HeroBannerContainer
